import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import i18n from './api/i18n';
import mainPlugins from '@/plugins/mainPlugins.js';
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';
import { onHttpError } from '@/utils/http-error-events';
import { createHttpErrorHandler } from '@/utils/http-error-handler';
import { translateWithFallback } from '@/utils/i18n';
import {
    initializeAppearanceMode,
    watchSystemAppearancePreference,
} from '@/utils/appearance';
import { setLoading, setNavigationLoading } from '@/plugins/loading';
import 'sweetalert2/dist/sweetalert2.min.css';

initializeAppearanceMode();
watchSystemAppearancePreference();

const app = createApp(App);
const t = i18n.global.t;
const te = i18n.global.te;

const translate = (key, fallback, options) =>
    translateWithFallback(t, key, fallback, options, te);

const handleHttpError = createHttpErrorHandler({
    Swal,
    router,
    store,
    translate,
    setLoading,
    setNavigationLoading,
});

app.config.errorHandler = error => {
    if (error?.isGlobalHttpErrorHandled && error?.response?.status === 402) {
        return;
    }

    console.error(error);
};

const initializeApp = () => {
    onHttpError(handleHttpError);

    app.use(mainPlugins);
    app.use(store);
    app.use(router);
    app.use(i18n);

    app.use(VueSweetalert2);

    app.mount('#app');
};

initializeApp();
